export const adminMaxWidth = 1100;

export enum AdminRoomTab {
  management = 'MANAGEMENT',
  template = 'TEMPLATE',
  homophone = 'HOMOPHONE',
}
